import { useTranslation } from 'react-i18next';
import { expiryCountdown } from './dealFilters';

type Props = {
  expiresAt: string | null | undefined;
};

export const DealExpiryPill = ({ expiresAt }: Props) => {
  const { t } = useTranslation();
  const countdown = expiryCountdown(expiresAt);
  if (!countdown) return null;

  return (
    <span className='font-poppins w-fit rounded bg-[#f6d06d] px-1.5 py-0.5 text-xs font-medium text-[#3c2c04]'>
      {countdown.unit === 'withinHour'
        ? t('deals.expires_within_hour')
        : t(countdown.unit === 'days' ? 'deals.expires_in_days' : 'deals.expires_in_hours', {
            count: countdown.count,
          })}
    </span>
  );
};
